import { useState, useEffect } from "react";
import { whatsappNumber, whatsappMessage } from "../data";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-sm border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
              <i className="ri-store-2-line text-lg md:text-xl"></i>
            </div>
            <div className="flex flex-col">
              <span className="font-heading font-bold text-foreground-900 text-base md:text-lg leading-tight">
                Plaj Cadde
              </span>
              <span className="text-xs text-foreground-600 leading-tight tracking-widest uppercase">
                Tekel
              </span>
            </div>
          </div>

          <div className="hidden md:flex items-center gap-4">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-5 py-2.5 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i>
              WhatsApp
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-900 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menü"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-3">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 px-5 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold cursor-pointer"
            >
              <i className="ri-whatsapp-line"></i>
              WhatsApp
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}